export default "__VITE_ASSET__4fd661d2__"